import { createReducer, on } from '@ngrx/store';
import {
  loadSubmissionActivity,
  loadSubmissionActivityFail,
  loadSubmissionActivitySuccess,
  loadWeightActivity,
  loadWeightActivityFail,
  loadWeightActivitySuccess,
  loadMealActivity,
  loadMealActivityFail,
  loadMealActivitySuccess,
  MealActivityItem,
  loadInteractionMetrics,
  loadInteractionMetricsFail,
  loadInteractionMetricsSuccess,
  loadPendingInvitations,
  loadPendingInvitationsFail,
  loadPendingInvitationsSuccess,
  SubmissionActivityItem,
  WeightActivityItem,
  InteractionMetricsRow,
  PendingInvitationRow,
  EventLogItem,
  loadEventLogs,
  loadEventLogsSuccess,
  loadEventLogsFail,
} from '../actions/admin-statistics.actions';

export interface AdminStatisticsState {
  submissions: SubmissionActivityItem[];
  weightEntries: WeightActivityItem[];
  mealEntries: MealActivityItem[];
  interactionMetrics: InteractionMetricsRow[];
  pendingInvitations: PendingInvitationRow[];
  eventLogs: EventLogItem[];

  loadingSubmissions: boolean;
  loadingWeight: boolean;
  loadingMeals: boolean;
  loadingInteractionMetrics: boolean;
  loadingPendingInvitations: boolean;
  loadingEventLogs: boolean;
}

const initialState: AdminStatisticsState = {
  submissions: [],
  weightEntries: [],
  mealEntries: [],
  interactionMetrics: [],
  pendingInvitations: [],
  eventLogs: [],

  loadingSubmissions: false,
  loadingWeight: false,
  loadingMeals: false,
  loadingInteractionMetrics: false,
  loadingPendingInvitations: false,
  loadingEventLogs: false,
};

export const adminStatisticsReducer = createReducer(
  initialState,

  on(loadSubmissionActivity, (state) => ({ ...state, loadingSubmissions: true })),
  on(loadSubmissionActivitySuccess, (state, { items }) => ({
    ...state,
    loadingSubmissions: false,
    submissions: items ?? [],
  })),
  on(loadSubmissionActivityFail, (state) => ({ ...state, loadingSubmissions: false })),

  on(loadWeightActivity, (state) => ({ ...state, loadingWeight: true })),
  on(loadWeightActivitySuccess, (state, { items }) => ({
    ...state,
    loadingWeight: false,
    weightEntries: items ?? [],
  })),
  on(loadWeightActivityFail, (state) => ({ ...state, loadingWeight: false })),

  on(loadMealActivity, (state) => ({ ...state, loadingMeals: true })),
  on(loadMealActivitySuccess, (state, { items }) => ({
    ...state,
    loadingMeals: false,
    mealEntries: items ?? [],
  })),
  on(loadMealActivityFail, (state) => ({ ...state, loadingMeals: false })),

  on(loadInteractionMetrics, (state) => ({ ...state, loadingInteractionMetrics: true })),
  on(loadInteractionMetricsSuccess, (state, { items }) => ({
    ...state,
    loadingInteractionMetrics: false,
    interactionMetrics: items ?? [],
  })),
  on(loadInteractionMetricsFail, (state) => ({ ...state, loadingInteractionMetrics: false })),

  on(loadPendingInvitations, (state) => ({ ...state, loadingPendingInvitations: true })),
  on(loadPendingInvitationsSuccess, (state, { items }) => ({
    ...state,
    loadingPendingInvitations: false,
    pendingInvitations: items ?? [],
  })),
  on(loadPendingInvitationsFail, (state) => ({
    ...state,
    loadingPendingInvitations: false,
  })),
  on(loadEventLogs, (state) => ({ ...state, loadingEventLogs: true })),
  on(loadEventLogsSuccess, (state, { items }) => ({
    ...state,
    loadingEventLogs: false,
    eventLogs: items ?? [],
  })),
  on(loadEventLogsFail, (state) => ({ ...state, loadingEventLogs: false }))
);
